<script setup lang="ts">
/* Components */
import HeaderCitySelectList from '@/components/Header/HeaderCitySelectList.vue'
const IconCloseInput = defineAsyncComponent(
  () => import('@/components/Icons/IconCloseInput.vue'),
)

type Props = {
  cityName: string
  isCitySelectListShow?: boolean
}

const props = defineProps<Props>()

const model = defineModel<boolean>()

const { isMobileOrTablet } = useDevice()

const searchQuery = ref<string | null>(null)

const onClear = () => {
  searchQuery.value = null
}

watch(
  () => props.isCitySelectListShow,
  () => (model.value = true),
)
</script>

<template>
  <the-dialog v-model="model" :max-width="1100" fixed :autofocus="false">
    <div data-e2e="city-list" class="city-select-dialog">
      <div class="city-select-dialog__header">
        <div class="city-select-dialog__search">
          <v-text-field
            v-model="searchQuery"
            autofocus
            flat
            variant="solo"
            placeholder="Начните вводить ваш город"
          >
            <template v-if="searchQuery && searchQuery.length > 0" #append>
              <v-btn
                icon
                size="small"
                variant="text"
                density="comfortable"
                @click="onClear"
              >
                <icon-close-input color="#BFB9B6" />
              </v-btn>
            </template>
          </v-text-field>
        </div>

        <div class="city-select-dialog__label">
          <span v-if="isMobileOrTablet">Изменить город</span>
          <span v-else>Выбран:</span>
        </div>

        <div class="city-select-dialog__selected">
          {{ cityName }}
        </div>
      </div>

      <header-city-select-list
        :search-query="searchQuery || ''"
        :is-visible="modelValue"
      />
    </div>
  </the-dialog>
</template>

<style scoped lang="scss">
.city-select-dialog {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;

  &__header {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    margin-bottom: 15px;
    font-size: 14px;

    @include media('<tablet') {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  &__search {
    width: 400px;
    height: 45px;
    overflow: hidden;
    background: #f6f5f4;
    border-radius: 6px;

    @include media('<desktop-mini') {
      width: 332px;
    }

    :deep() {
      input::placeholder {
        color: $unactive-grey;
        opacity: unset;
      }

      .v-input__append-inner {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
      }
      @include media('<tablet') {
        order: 2;
        width: 100%;
      }

      .v-field__input {
        min-height: 43px !important;
        padding: 0 0 0 12px;
        background: #f6f5f4 !important;
      }

      .v-input__append {
        margin-right: 12px;
        margin-left: 4px;
      }

      .v-icon {
        color: #b7b0ac !important;
      }
    }
  }

  &__label {
    margin-left: 20px;
    color: $text-light;

    @include media('<tablet') {
      margin-bottom: 15px;
      margin-left: 0;
      font-size: 16px;
      font-weight: 700;
      color: $text-black;
    }
  }

  &__selected {
    margin-left: 10px;
    font-weight: 600;
    color: $text-black;

    @include media('<tablet') {
      margin-bottom: 24px;
      margin-left: 0;
    }
  }
}
</style>
